import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class ToastService {
  _toastMessage = ''
  _toastType = ''
  _toastState = false;

  constructor( ) {}

  initializeMessage(message: string, type: string) {
    let toastElement = document.getElementById('mainToastConatiner');
    this._toastMessage = message;
    this._toastType = type;
    this._toastState = true;
    
    toastElement.classList.add('show');
  }

  closeMessage() {
    let toastElement = document.getElementById('mainToastConatiner');
    toastElement.classList.remove('show');
    this._toastMessage = '';
    this._toastType = '';
    this._toastState = false;
  }
}

